import { render, staticRenderFns } from "./RemindList.vue?vue&type=template&id=73ed0d2b&scoped=true&"
import script from "./RemindList.vue?vue&type=script&lang=js&"
export * from "./RemindList.vue?vue&type=script&lang=js&"
import style0 from "./RemindList.vue?vue&type=style&index=0&id=73ed0d2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ed0d2b",
  null
  
)

export default component.exports